import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const PlusIcon = ({ accentColor, filterId }) => (
    <svg width="44" height="44" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g filter={`url(#${filterId})`}>
            <path d="M4 22C4 10.9543 12.9543 2 24 2C35.0457 2 44 10.9543 44 22C44 33.0457 35.0457 42 24 42C12.9543 42 4 33.0457 4 22Z" fill="white" />
            <path d="M25.6922 11.8462C25.6922 10.825 24.9359 10 23.9999 10C23.0638 10 22.3076 10.825 22.3076 11.8462V20.1538H14.6922C13.7561 20.1538 12.9999 20.9788 12.9999 22C12.9999 23.0212 13.7561 23.8462 14.6922 23.8462H22.3076V32.1538C22.3076 33.175 23.0638 34 23.9999 34C24.9359 34 25.6922 33.175 25.6922 32.1538V23.8462H33.3076C34.2436 23.8462 34.9999 23.0212 34.9999 22C34.9999 20.9788 34.2436 20.1538 33.3076 20.1538H25.6922V11.8462Z" fill={accentColor} />
        </g>
        <defs>
            <filter id={filterId} x="0" y="0" width="48" height="48" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.72549 0 0 0 0 0.631373 0 0 0 0 0.909804 0 0 0 0.15 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
            </filter>
        </defs>
    </svg>
);

class DashboardCard extends Component {

    render() {
        const {
            id,
            title,
            total,
            iconSrc,
            path,
            isAdmin,
            isSuperAdmin,
            pathTotal,
            backgroundColor,
            plusColor,
        } = this.props;

        const accentColor = plusColor || backgroundColor;
        const showPlusLink = !(id === 'client-card' && !isSuperAdmin && !isAdmin);

        return (
            <div
                className="dashboard-stat-card"
                style={{ backgroundColor }}
            >
                <div className="dashboard-stat-card__icon">
                    <img src={iconSrc} alt="" />
                </div>
                <div className="dashboard-stat-card__bottom">
                    <div className="dashboard-stat-card__text">
                        <Link to={pathTotal} className="dashboard-stat-card__total">
                            {total}
                        </Link>
                        <p className="dashboard-stat-card__label">{title}</p>
                    </div>
                    <div className="dashboard-stat-card__action">
                        {showPlusLink ? (
                            <Link to={path} className="dashboard-stat-card__plus-link" aria-label={this.props.footerText}>
                                <PlusIcon accentColor={accentColor} filterId={`${id}-plus-filter`} />
                            </Link>
                        ) : (
                            <span className="dashboard-stat-card__plus-link">
                                <PlusIcon accentColor={accentColor} filterId={`${id}-plus-filter`} />
                            </span>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

DashboardCard.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
    pathTotal: PropTypes.string.isRequired,
    iconSrc: PropTypes.string.isRequired,
    footerText: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    backgroundColor: PropTypes.string.isRequired,
    plusColor: PropTypes.string,
};

export default DashboardCard;
